const addressTypeEnum = Object.freeze({
    SHIPPING         : 5,
    BILLING       : 10,
});
export default addressTypeEnum;
